module.exports = __webpack_public_path__ + "img/nuwa_developer_infobox.4ede5d8e.png";